import React from 'react';
import { isCosBrand } from "@pb/utils/brandConfig";
import IconWrapper from '../IconWrapper';
const RadioButtonActive = (props) => {
    switch (true) {
        case isCosBrand:
            return (React.createElement(IconWrapper, Object.assign({}, props),
                React.createElement("path", { className: "outerElement", d: "M8 16A8 8 0 1 0 8 0a8 8 0 0 0 0 16Z" }),
                React.createElement("path", { className: "innerElement", d: "M9.95 8a1.95 1.95 0 1 1-3.9 0 1.95 1.95 0 0 1 3.9 0Z" })));
        default:
            return (React.createElement(IconWrapper, Object.assign({}, props),
                React.createElement("path", { d: "M12 2c5.523 0 10 4.477 10 10s-4.477 10-10 10S2 17.523 2 12 6.477 2 12 2zm0 1a9 9 0 100 18 9 9 0 000-18zm0 2a7 7 0 110 14 7 7 0 010-14z" })));
    }
};
export default RadioButtonActive;
//# sourceMappingURL=RadioButtonActive.js.map